import { createContext, FC, useState } from 'react';
import { useDefaultRestApiFetcher } from '../fetchers/rest-api-fetcher';
import { ApiClient, createApiClient } from '../rest-api/generated/laravel-typed-openapi';
import { TanstackQueryApiClient } from '../rest-api/generated/tanstack.client';

type Props = {
  children: React.ReactNode;
  getToken: () => Promise<string | null>;
  restApiServiceUrl: string;
};

type TypedOpenApiState = {
  apiClient: ApiClient;
  tanstackApiClient: TanstackQueryApiClient;
} | null;

export const TypedOpenApiContext = createContext<TypedOpenApiState>(null);

export const TypedOpenApiProvider: FC<Props> = ({ children, restApiServiceUrl }) => {
  const fetcher = useDefaultRestApiFetcher();
  const [apiClient] = useState(() => createApiClient({ fetch: fetcher }, restApiServiceUrl));

  const tanstackApiClient = new TanstackQueryApiClient(apiClient);

  return (
    <TypedOpenApiContext.Provider value={{ apiClient, tanstackApiClient }}>{children}</TypedOpenApiContext.Provider>
  );
};
